<template>
  <div>
    <el-divider content-position="left">{{ resourceTitle }}</el-divider>
    <slot name="desc"></slot>
    <el-row style="margin-bottom: 0.2rem">
      <el-col :span="18">
        <slot name="filter"><div style="width: 1px; height: 1px;"></div></slot>
      </el-col>
      <el-col :span="6" class="tr">
        <slot name="operation"></slot>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'ResourcePageHeader',
  props: {
    resourceTitle: {
      type: String,
      default: ''
    }
  },
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style lang="stylus" scoped>
.header-style {
  z-index: 2;
  height: auto !important;
  padding: 0 !important;
}
.tr {
  text-align right;
}
</style>



// WEBPACK FOOTER //
// src/common/ResourceListPageHeader.vue